export default "__VITE_ASSET__ce2b7fbb__"